import * as React from 'react';

// eslint-disable-next-line react-hooks/exhaustive-deps
const useMount = (func: React.EffectCallback) => React.useEffect(func, []);

export default useMount;
